"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusBools = exports.injectStatusBools = void 0;
const _1 = require(".");
/**
 *
 * @param items: raw list of funding opportunities
 * @returns Parsed list of funding opportunities with status booleans
 */
function injectStatusBools(items) {
    return items.map((item) => (Object.assign(Object.assign({}, item), getStatusBools(item.status))));
}
exports.injectStatusBools = injectStatusBools;
/**
 *
 * @param status: funding opportunity status
 * @returns status booleans to make checks less verbose
 */
function getStatusBools(status) {
    return {
        isArchived: status === _1.FundingOpportunityStatus.ARCHIVED,
        isActive: status === _1.FundingOpportunityStatus.ACTIVE,
        isInterested: status === _1.FundingOpportunityStatus.INTERESTED,
    };
}
exports.getStatusBools = getStatusBools;
//# sourceMappingURL=helpers.js.map